import React, { useState, useEffect } from 'react'
import logo from "../stock/nexus/logo.png"
import { NavLink, useLocation } from 'react-router-dom'
import { AiOutlineMenu } from "react-icons/ai"
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { HashLink } from 'react-router-hash-link';
import { IoCloseSharp } from "react-icons/io5";


function Navbar() {
    const [showMenu, setShowMenu] = useState(false)
    
    const toggleMenu = () => {
        setShowMenu(!showMenu)
    }

  const location = useLocation();

 const visiblePaths = [
   "/", 
    // "/login", 
    // "/signup", 
    // "/verify-account", 
    // "/verify-account/username", 
    // "/dashboard", 
    // '/trades', 
    // '/transactions', 
    // '/deposits', 
    // '/withdrawals', 
    // '/pendingDeposits', 
];

// 2. Check if the current path is NOT in the list.
// If the path IS NOT in the list, the component SHOULD be hidden.
const shouldHideComponent = !visiblePaths.includes(location.pathname);

    const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
  if (showMenu) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
}, [showMenu]);

  
  return (
    <div style={{ display: shouldHideComponent ? "none" : "block" }}>
      <div className={`navigation ${isScrolled ? "scrolled" : ""} ${showMenu ? "menu-open" : ""}`}>

            <div className="navbar">
            <NavLink 
            to="/" 
            className="logo-container" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img src={logo} alt="nexusforgefx" />
            <div className="name">
              <h3>NEXUS</h3>
              <p>FORGE FX</p>
            </div>
          </NavLink>


                <div className="links">
                    {/* <li>
                     <NavLink  className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } to="/about">About</NavLink>
                    </li> */}
                    <li>
                    <HashLink  className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } smooth to="#how">How It Works</HashLink>
                    </li>
                    <li>
                    <HashLink  className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } smooth to="#tradables">Tradable Assets</HashLink>
                   </li>
                   <li>
                    <HashLink  className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } smooth to="#faqs">Faqs</HashLink>
                   </li>
                </div>

                <div className="start">
                    <NavLink to='/signup' className='desktop'>Register</NavLink>
                    <NavLink to='/login'>Sign in</NavLink>
                    {showMenu ? (
                <div>
                    <IoCloseSharp onClick={toggleMenu} className='mobile'/>
                </div>
                ) : (
                <AiOutlineMenu onClick={toggleMenu} className='mobile' />
                )}
                </div>
                
                {showMenu && (
                <div className="mobile-menu">
                   <NavLink>About Us <MdOutlineKeyboardArrowRight className='arrow'/></NavLink>
                   <NavLink>How It Works <MdOutlineKeyboardArrowRight className='arrow'/></NavLink>
                   <NavLink>Faqs <MdOutlineKeyboardArrowRight className='arrow'/></NavLink>
                   <NavLink>Get Help <MdOutlineKeyboardArrowRight className='arrow'/></NavLink>

                   <span></span>

                   <div className="start-mobile">
                    <NavLink to='/signup'>Register</NavLink>
                    <NavLink to='/login'>Sign in</NavLink>
                   </div>
                </div>
                )}


            </div>
        </div>
    </div>
  )
}

export default Navbar